/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getGeneralRevisionList = (payload, callback) =>
  req.list(
    c.GET_GENERAL_REVISION,
    'api/v1/rpt/administrator/settings/general_revisions',
    payload,
    callback
  );

export const getSingleGeneralRevision = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_GENERAL_REVISION,
    `api/v1/rpt/administrator/settings/general_revisions/${id}`,
    payload,
    callback
  );

export const createGeneralRevision = (payload, callback) =>
  req.create(
    c.CREATE_GENERAL_REVISION,
    'api/v1/rpt/administrator/settings/general_revisions',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateGeneralRevision = (id, payload, callback) =>
  req.update(
    c.UPDATE_GENERAL_REVISION,
    `api/v1/rpt/administrator/settings/general_revisions/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeGeneralRevision = (id, payload, callback) =>
  req.remove(
    c.REMOVE_GENERAL_REVISION,
    `api/v1/rpt/administrator/settings/general_revisions/${id}`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );
